export const PRODUCT_SKU = {
  OSK03: 'OSK03',
  ORF03: 'ORF03',
  OCK01: 'OCK01',
  OECK01: 'OECK01',
  EST01: 'EST01',
} as const;
